export default __webpack_public_path__ + "static/fingAndroid-a54cac3fd35145ce2a880e40276bc959.webp";